
export default {
  props: ["dataInfo"],
};
